import { post } from "../../utils/Backend";
import type {
  CsConversationBootstrap,
  CsListMessagesResult,
  CsMessage,
  CsPollNewMessagesResult,
  CsSyncReadedAndGetUnreadResult,
} from "./SpaceCustomerServiceTypes";
import { mockGetOrCreateConversation, mockListMessages, mockMarkRead, mockPollNewMessages, mockSendMessage, mockSyncReadedAndGetUnread } from "./SpaceCustomerServiceMock";

const mock = false;
const BASE = "/lark/app/customerService";

export const SpaceCustomerChatApi = {
  async getOrCreateConversation(spaceId: string): Promise<CsConversationBootstrap | string> {
    if (mock && false) {
      return mockGetOrCreateConversation();
    }
    return post<{ csChannel: string; spaceId: string }, CsConversationBootstrap>(
      `${BASE}/getOrCreateConversation`,
      { csChannel: "SPACE", spaceId }
    );
  },

  async listMessages(
    conversationId: string,
    beforeMessageId?: string | null,
    size = 30
  ): Promise<CsListMessagesResult | string> {
    if (mock && false) {
      return mockListMessages(beforeMessageId);
    }
    return post<
      { conversationId: string; beforeMessageId?: string; size?: number },
      CsListMessagesResult
    >(`${BASE}/listMessages`, {
      conversationId,
      beforeMessageId: beforeMessageId ?? undefined,
      size,
    });
  },

  async pollNewMessages(
    conversationId: string,
    afterMessageId?: string | null
  ): Promise<CsPollNewMessagesResult | string> {
    if (mock && false) {
      return mockPollNewMessages(afterMessageId);
    }
    return post<
      { conversationId: string; afterMessageId?: string },
      CsPollNewMessagesResult
    >(`${BASE}/pollNewMessages`, {
      conversationId,
      afterMessageId: afterMessageId ?? undefined,
    });
  },

  async syncReadedAndGetUnread(
    conversationId: string,
    afterMessageId?: string | null,
    readUpToMessageId?: string | null,
    afterRecallEventId?: string | null
  ): Promise<CsSyncReadedAndGetUnreadResult | string> {
    if (mock && false) {
      return mockSyncReadedAndGetUnread(conversationId, afterMessageId, readUpToMessageId);
    }
    return post<
      {
        conversationId: string;
        afterMessageId?: string;
        readUpToMessageId?: string;
        afterRecallEventId?: string;
      },
      CsSyncReadedAndGetUnreadResult
    >(`${BASE}/syncReadedAndGetUnread`, {
      conversationId,
      afterMessageId: afterMessageId ?? undefined,
      readUpToMessageId: readUpToMessageId ?? undefined,
      afterRecallEventId: afterRecallEventId ?? undefined,
    });
  },

  async sendMessage(
    conversationId: string,
    content: string,
    messageType: "TEXT" | "IMAGE" = "TEXT"
  ): Promise<CsMessage | string> {
    if (mock && false) {
      return mockSendMessage(content);
    }
    return post<{ conversationId: string; content: string; messageType?: string }, CsMessage>(
      `${BASE}/sendMessage`,
      { conversationId, content, messageType }
    );
  },

  async prepareImageUpload(
    conversationId: string,
    fileExt: string
  ): Promise<{ objectKey: string } | string> {
    if (mock && false) {
      return { objectKey: `cs/${conversationId}/mock.${fileExt}` };
    }
    return post<{ conversationId: string; fileExt: string }, { objectKey: string }>(
      `${BASE}/prepareImageUpload`,
      { conversationId, fileExt }
    );
  },

  async markRead(conversationId: string): Promise<boolean | string> {
    if (mock && false) {
      return mockMarkRead();
    }
    return post<{ conversationId: string }, boolean>(`${BASE}/markRead`, { conversationId });
  },
};
